import { Box, Button } from '@nimbus-ds/components';
import { MarketingIcon, GiftBoxIcon, TagIcon } from '@nimbus-ds/icons';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useNavegate } from 'App/hooks';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { MARKETING_ROUTES } from 'domains/Marketing/marketingRoutes';
import {
  SectionAppCard,
  SectionAppCardDomains,
} from 'domains/PartnersApps/components';
import emptyCouponsImage from './empty-coupons.png';

export function CouponsListEmpty() {
  const t = useTranslationMarketing('coupons.emptyResults');
  const { goTo } = useNavegate();
  const handlePrimary = () => goTo(MARKETING_ROUTES.newCoupon);
  return (
    <InitialScreen>
      <InitialScreen.Hero
        subtitle={t('subtitle').toUpperCase()}
        title={t('title')}
        bullets={[
          <InitialScreen.Bullet
            key="bullet1"
            icon={<MarketingIcon />}
            text={t('bullet1')}
          />,
          <InitialScreen.Bullet
            key="bullet2"
            icon={<GiftBoxIcon />}
            text={t('bullet2')}
          />,
          <InitialScreen.Bullet
            key="bullet3"
            icon={<TagIcon />}
            text={t('bullet3')}
          />,
        ]}
        image={
          <img
            src={emptyCouponsImage}
            width="100%"
            height="auto"
            alt={t('subtitle')}
          />
        }
        actions={
          <Button onClick={handlePrimary} appearance="primary">
            {t('action')}
          </Button>
        }
      >
        <Box>
          <SectionAppCard
            source={MARKETING_ROUTES.couponList}
            appCategory="marketing"
            domain={SectionAppCardDomains.COUPONS}
          />
        </Box>
      </InitialScreen.Hero>
    </InitialScreen>
  );
}
